// Copyright (C) Microsoft. All rights reserved.
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Checkbox as FluentCheckbox, concatStyleSets, useTheme } from "@fluentui/react";
import React from "react";
import { getBaseCheckboxStyle } from "./Checkbox.styles";
// The Checkbox component is a generic component which wraps the FluentUI Checkbox component and applies styling to Windows Visual Toolkit specifications.
// The component also implements accessible keyboarding behavior missing from the FluentUI Checkbox component. Please do not use the FluentUI Checkbox component
// directly, and opt to always use this Checkbox component instead.
export const Checkbox = (_a) => {
    var { checked, onChange, styles } = _a, rest = __rest(_a, ["checked", "onChange", "styles"]);
    const theme = useTheme();
    return (React.createElement(FluentCheckbox, Object.assign({}, rest, { inputProps: {
            onKeyPress: (ev) => {
                if (ev.key === " ") {
                    checked = !checked;
                }
            },
        }, checked: checked, onChange: onChange, styles: concatStyleSets(getBaseCheckboxStyle(theme, checked), styles) })));
};
